/* eslint no-param-reassign: "error" */
import Vue from 'vue';

Vue.directive('click-outside', {
  bind(el, binding) {
    const bubble = binding.modifiers.bubble;
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target && !e.target.className.includes('hamburger'))) {
        binding.value(e);
      }
    };
    el.vueClickOutside = handler;
    document.addEventListener('click', handler);
  },

  unbind(el) {
    document.removeEventListener('click', el.vueClickOutside);
    el.vueClickOutside = null;
  },
});



// WEBPACK FOOTER //
// ./src/directives/index.js